import React, { createContext, type ReactNode, useContext, useMemo } from 'react'

type UserIsDataAdminValue = {
  userIsDataAdmin: boolean
}

const UserIsDataAdmin = createContext<UserIsDataAdminValue | undefined>(undefined)

export const useUserIsDataAdmin = (): UserIsDataAdminValue => {
  const context = useContext(UserIsDataAdmin)
  if (!context) throw new Error('You need to use the DataAdminProvider to use the useUserIsDataAdmin')
  return context
}

type Props = {
  children: ReactNode
  dataAdminRole: string | null
}

export default function DataAdminProvider({ children, dataAdminRole }: Props): JSX.Element {
  const isDataAdmin = useMemo(
    () => ({ userIsDataAdmin: Boolean(dataAdminRole?.match(/^Data Admin [4-6]$/i)) }) satisfies UserIsDataAdminValue,
    [dataAdminRole]
  )

  return <UserIsDataAdmin.Provider value={isDataAdmin}>{children}</UserIsDataAdmin.Provider>
}
